import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { camps } from '../../../../models/models.generated';
import { campsenum } from '../../../../models/enums.generated';
import { CampsEnumTranslationService } from '../../../../services/camps-enum-translation.service';

@Component({
    selector: 'app-selected-session-info',
    templateUrl: './selected-session-info.component.html',
    styleUrls: ['./selected-session-info.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectedSessionInfoComponent {

    session = input<camps.SellCampSessionModel>(null);

    constructor(
        private translateService: CampsEnumTranslationService) {
    }

    public timeVariantTranslation(type: campsenum.TimeRangeVariantType) {
        return this.translateService.timeVariant(type);
    }
}
